// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"5cbace4b4355c654dfea","627":"97c11fac209a41ef6853"}[chunkId] + ".js";
};